export class BaseFilterModel {
  toQueryString(): string {
    let queryString = '?';
    const properties = Object.getOwnPropertyNames(this);

    for (const property of properties) {
      if (this[property] && property !== '__observers__' && property !== 'dateFormat') {
        queryString += property + '=' + encodeURIComponent(this[property]) + '&';
      }
    }

    return queryString;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/base/base-filter.model.ts